import { WorkspaceMembersPage } from 'app/src/components/WorkspacePages/WorkspaceMembersPage';
import { controllerEvents } from './controllerEvents';
import { renderTopLevelComponent } from './renderTopLevelComponent';

export const organizationMembersPage = ({
  orgNameOrId,
}: {
  orgNameOrId: string;
}) => {
  controllerEvents.trigger('clearPreviousView', { isNextViewReact: true });
  controllerEvents.trigger('setViewType', 'OrganizationMembersViewNew');
  renderTopLevelComponent(<WorkspaceMembersPage orgNameOrId={orgNameOrId} />);
};
